import { render, staticRenderFns } from "./DashedBox.vue?vue&type=template&id=ae679878&scoped=true&"
import script from "./DashedBox.vue?vue&type=script&lang=js&"
export * from "./DashedBox.vue?vue&type=script&lang=js&"
import style0 from "./DashedBox.vue?vue&type=style&index=0&id=ae679878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae679878",
  null
  
)

/* custom blocks */
import block0 from "./DashedBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae679878')) {
      api.createRecord('ae679878', component.options)
    } else {
      api.reload('ae679878', component.options)
    }
    module.hot.accept("./DashedBox.vue?vue&type=template&id=ae679878&scoped=true&", function () {
      api.rerender('ae679878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/DashedBox.vue"
export default component.exports